import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {EntitlementSearchData} from "./entitlement-search.data";
import {EntitlementStatus} from "./entitlement.data";

@Injectable()
export class EntitlementSearchModel extends SearchModel<EntitlementSearchData> {
    constructor(injector: Injector) {
        super(injector, EntitlementSearchData);
    }

    override getIdentifierField(): string {
        return "id";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }

    override getResourceName(): string {
        return "entitlement";
    }

    override getResource(): string {
        return "deal";
    }

    override isDiscontinued(item: EntitlementSearchData): boolean {
        return item.status == EntitlementStatus.DISCONTINUED;
    }
}
